import { ChangeDetectionStrategy, Component, ViewEncapsulation, input, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import type { LoginEduFormViewData } from '@sites/entity-core/src/widget/login-edu/styles/login-edu.css-vars';

/**
 * Static preview of the sign-in modal, teleported into the editor's modal
 * outlet by `field-input-settings`. Nothing here is interactive — the whole
 * dialog renders with `pointer-events: none` — so the fields are plain inputs
 * and the buttons are no-ops; only the styling is real.
 */
@Component({
    selector: 'web-edu-login-modal-preview',
    templateUrl: './edu-login-modal-preview.component.html',
    styleUrls: ['./edu-login-modal-preview.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    imports: [TranslateModule],
})
export class EduLoginModalComponent {
    /** Styling contract of the widget's form — see `login-edu-view.css-vars.ts`. */
    public readonly styleBag = input.required<LoginEduFormViewData>();

    public readonly showPassword = signal<boolean>(false);

    public onSignIn(): void {}

    public onPasswordRecovery(): void {}

    public toggleShowPassword(): void {
        // this.showPassword.update((value) => !value);
    }
}
